import React from "react"
import styled from "styled-components"
import media from "styled-media-query"

import { colors } from "~/styles"
import shape from "~/assets/images/one.svg"
import circle from "~/assets/images/three.svg"

export const Container = styled.div.attrs(props => {
  return {
    children: (
      <figure>
        <img src={shape} className="shape" />
        {props.children}
      </figure>
    ),
  }
})`
  position: relative;
  margin-top: -30rem;

  overflow: hidden;

  > figure {
    &:before {
      position: absolute;
      top: 0;
      right: -5px;
      width: 10px;
      height: 100%;
      background-color: #f97503;
      content: "";
    }
  }

  ${media.greaterThan("medium")`
    clip-path: polygon(0 23.5%, 100% 0, 100% 100%, 0% 100%);
    
    &:before {
      position: absolute;
      top: 0rem;
      left: 0;
      content: url(${circle});
      z-index: 10;
    }
  `}
`

export const Content = styled.div`
  position: relative;

  width: 100%;
  margin-top: -20px;
  padding-bottom: 100px;

  display: flex;
  flex-direction: column;
  align-items: center;

  ${media.greaterThan("medium")`
    flex-direction: row;
    justify-content: center;
  `}

  background: #FF7500;
`
